(function () {
  function mountModal() {
    var modal = document.getElementById('flipbookModal');
    if (!modal) return null;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    return modal;
  }

  function ensureLoaded() {
    var modal = mountModal();
    if (!modal) return;
    var iframe = modal.querySelector('iframe[data-flipbook-src]');
    if (!iframe || iframe.dataset.flipbookLoaded) return;
    iframe.src = iframe.getAttribute('data-flipbook-src');
    iframe.dataset.flipbookLoaded = 'true';
  }

  function openModal() {
    var modal = mountModal();
    if (!modal) return;
    ensureLoaded();
    modal.hidden = false;
    document.body.classList.add('flipbook-modal-open');
  }

  function closeModal() {
    var modal = document.getElementById('flipbookModal');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('flipbook-modal-open');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountModal);
  } else {
    mountModal();
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('.open-flipbook')) {
        event.preventDefault();
        event.stopPropagation();
        var productModal = document.querySelector('product-modal.product-media-modal[open]');
        if (productModal && typeof productModal.hide === 'function') {
          productModal.hide();
        }
        openModal();
        return;
      }
      if (
        event.target.id === 'closeFlipbook' ||
        event.target.closest('#closeFlipbook') ||
        event.target.id === 'flipbookModal'
      ) {
        closeModal();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
})();
